import * as ko from './ko'
import * as en from './en'
import * as ja from './ja'

const temp = {
  en,
  ko,
  ja
}

export default temp